import { getTime } from './date';
import deviceType from './const/deviceType';

export const deviceState = [
  { value: -1, label: '未连接' },
  { value: 0, label: '正常' },
  { value: 1, label: '预警' },
  { value: 2, label: '报警' },
  { value: 61, label: '维护' },
  { value: 71, label: '故障' },
  { value: 81, label: '采集基线中' }
];

// 设备/地图
export const showModels = [
  { label: 'map', text: '地图' },
  { label: 'scene', text: '场景' }
];

// 状态报告模式
export const stateReportModels = [
  { label: 'all', text: '全部' },
  { label: 'warn', text: '预警' },
  { label: 'danger', text: '报警' }
];

// 设备不同状态在地图上的图标
export const stateMapMarker = {
  undefined: 'static/image/unconnect.png',
  '-1': 'static/image/unconnect.png',
  0: 'static/image/success.png',
  1: 'static/image/warn.png',
  2: 'static/image/danger.png',
  61: 'static/image/fix.png',
  71: 'static/image/fault.png',
  81: 'static/image/marker.png'
};

// 状态图片名称
export const stateImg = {
  undefined: 'unconnect',
  '-1': 'unconnect',
  0: 'success',
  1: 'warn',
  2: 'danger',
  61: 'fix',
  71: 'fault',
  81: 'collect'
};

// 地图主题
export const mapThemes = [
  { label: '靛青蓝', id: 'dark', color: '#033447' },
  { label: '标准', id: 'light', color: '#fcf9f2' }
];

// 化学战剂浓度
export const concentrations = {
  0: '无',
  1: '低',
  2: '中',
  3: '高'
};

// runstate字段值映射关系
export const runstateText = {
  undefined: '离线',
  '-1': '离线',
  1: '在线',
  2: '维护',
  3: '故障',
  4: '采集基线中'
};

// 设备连接状态(集合state和runstate判断的结果)，主要用任务管理列表
export const pointState = {
  undefined: '未连接',
  '-1': '未连接',
  0: '正常',
  1: '预警',
  2: '报警',
  61: '维护',
  71: '故障',
  81: '采集基线中'
};

// 滚动条样式
export const scrollbarStyles = {
  bold: 'bold-sc',
  thin: 'thin-sc',
  none: 'none-sc'
};

// 状态颜色
export const stateColor = {
  undefined: '#a9a9a9',
  '-1': '#a9a9a9',
  0: '#03b36e',
  1: '#FF6100',
  2: '#FF4847',
  61: '#ffd04f',
  71: '#ffbb00',
  81: '#00eeff'
};

// 参数浓度
export const sceneLevel = {
  1: 'lowLevel',
  2: 'midLevel',
  3: 'highLevel'
};

// 参数浓度
export const lowSceneLevel = {
  1: 'low',
  2: 'mid',
  3: 'high'
};

// 运行状态

export const runstateDict1 = {
  0: '离线',
  1: '在线',
  2: '维护中',
  3: '故障',
  4: '采集基线中'
};

export const runstateDict2 = {
  离线: 0,
  在线: 1,
  维护中: 2,
  故障: 3,
  采集基线中: 4
};

// 月份
export const monthDict = {
  0: '一月',
  1: '二月',
  2: '三月',
  3: '四月',
  4: '五月',
  5: '六月',
  6: '七月',
  7: '八月',
  8: '九月',
  9: '十月',
  10: '十一月',
  11: '十二月'
};

// 设备类型reg
export const deviceTypeReg = [
  {
    name: 'raman',
    reg: /^RAMAN$/
  },
  {
    name: 'ef',
    reg: /^EF\-?/
  },
  {
    name: 'fcbr',
    reg: /^FCBR\-\d+/
  },
  {
    name: 'cr2500',
    reg: /^CR\-?\d+/
  },
  {
    name: 'b02',
    reg: /^4\d$/
  },
  {
    name: 'rs500',
    reg: /^RS\-?500/
  },
  {
    name: 'bm3001',
    reg: /^BM\-?3001/
  },
  {
    name: 'chempro',
    reg: /^CHEMPRO$/
  },
  {
    name: 'fitrm',
    reg: /^FITRM/i
  },
  {
    name: 'ngp2',
    reg: /^NGP\-?\d*/
  },
  {
    name: 'rg500',
    reg: /^RG\-?500/
  },
  {
    name: 'rmsc',
    reg: /^RMSC/
  },
  {
    name: 'rmse',
    reg: /^RMSE/
  },
  {
    name: 'vp100',
    reg: /^VP\-?\d+/
  }
];

// 断连判断时间
export const unconnectTime = {
  0: 40000, // 默认
  1: 40000, // 监测 cd602 设备心跳30s一次
  2: getTime('m') * 2 // 检测
};

export const unconnectTimeByType = {
  [deviceType.CD_603]: 60000,
  [deviceType.GW1021]: 90000,
  [deviceType.GW1034M]: 90000
};
